import {
  listResources,
  ListResourcesRequestParams,
} from "@/requests/libraries/list-resources.request";
import { useQuery } from "@tanstack/react-query";

export const useListResources = (params: ListResourcesRequestParams) => {
  return useQuery({
    queryKey: [
      "companies",
      params.companyId,
      "resource-libraries",
      params.resourceLibraryId,
      "resources",
      {
        q: params.q,
        types: params.types,
        page: params.page,
        size: params.size,
        sort: params.sort,
      },
    ],
    queryFn: () => listResources(params),
    enabled: !!params.companyId && !!params.resourceLibraryId,
  });
};
